import { useContext } from "react"
import ReactVisibilitySensor from "react-visibility-sensor"
import { LangContext } from "../../App"

const BorderLeftBox = ({ title, subtitle, spam } : { title : string, subtitle? : string, spam? : string }) => {
  const { lang } = useContext(LangContext);

  return (
    <ReactVisibilitySensor
      partialVisibility
    >
      {({isVisible} : any) => (
        <div className={`border-left-box ${lang === 0 ? "" : "rtl"} ${isVisible ? "visible" : ""}`}>
            <h2 className={`box-title`}>
              {title}
              {spam ? <p className="spam-text">{spam}</p> : ""}
            </h2>
            
            {subtitle ? <p className={`box-subtitle`}>{subtitle}</p> : ""}
        </div>
      )}
    </ReactVisibilitySensor>
  )
}

//  ${lang === 0 ? "an-move-left-fade-in" : "an-move-right-fade-in"} ${isVisible ? "an-active" : ""}

export default BorderLeftBox